"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
exports.getMapFromDimensions = function (dimensions) {
    var lookup = {};
    dimensions.forEach(function (d) {
        lookup[d.uniqueKey] = d;
    });
    return lookup;
};
exports.addNewDimension = function (dimensions, dimension) {
    return dimensions.concat([dimension]);
};
exports.deleteDimension = function (dimensions, dimensionKey) {
    return dimensions.filter(function (dimension) { return dimension.uniqueKey !== dimensionKey; });
};
exports.renameDimension = function (dimensions, dimensionKey, name) {
    var search = lodash_1.findIndex(dimensions, function (ad) {
        return ad.uniqueKey === dimensionKey;
    });
    if (search >= 0) {
        var newDimensions = dimensions.slice();
        // update copy in-place
        var newDimension = __assign({}, newDimensions[search], { name: name });
        newDimensions[search] = newDimension;
        return newDimensions;
    }
    return dimensions;
};
exports.isUnsavedDimension = function (dimension) {
    return !dimension.id;
};
